import ProductsContainer from "containers/ProductsContainer";
import ProductDetailContainer from "containers/ProductDetailContainer";
import TermsConditionsContainer from "containers/TermsConditionsContainer";
import FaqContainer from "containers/FaqContainer";

import { RouteObject } from "types";

export const MinniemuseShopRoutes: { [id: string]: RouteObject } = {
  PRODUCTS: {
    path: "/",
    exact: true,
    component: ProductsContainer
  },
  PRODUCT_DETAIL: {
    path: "/products/:productHandle",
    exact: true,
    component: ProductDetailContainer,
    base: "/products/"
  },
  TERMS_CONDITIONS: {
    path: "/terms-conditions",
    exact: true,
    component: TermsConditionsContainer
  },
  FAQ: {
    path: "/faq",
    exact: true,
    component: FaqContainer
  }
};

export enum ExternalRoutes {
  MINNIEMUSE_HOME_LINK = "https://www.minniemuse.com",
  MINNIEMUSE_ABOUT_LINK = "https://www.minniemuse.com/about"
}
